// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.who-we-are-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 40px;
}

@media screen and (min-width: 1024px) {
  .who-we-are-container {
    flex-direction: row;
  }
}

.who-we-are-container > h2 {
  font-size: 2em;
  text-wrap: nowrap;
}

@media screen and (min-width: 768px) {
  .who-we-are-container > h2 {
    width: 50%;
    text-align: center;
    font-size: 3em;
  }
}

.who-we-are-container > img {
  width: auto;
  max-width: 100%;
  height: 100%;
  border-radius: 39% 61% 71% 29% / 41% 45% 55% 59% ;
}

@media screen and (min-width: 768px) {
  .who-we-are-container > img {
    max-width: 50%;
  }
}

.who-we-are-paragraphs-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/quienes-somos/quienes-somos.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,UAAU;IACV,kBAAkB;IAClB,cAAc;EAChB;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB","sourcesContent":[".who-we-are-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 40px;\n}\n\n@media screen and (min-width: 1024px) {\n  .who-we-are-container {\n    flex-direction: row;\n  }\n}\n\n.who-we-are-container > h2 {\n  font-size: 2em;\n  text-wrap: nowrap;\n}\n\n@media screen and (min-width: 768px) {\n  .who-we-are-container > h2 {\n    width: 50%;\n    text-align: center;\n    font-size: 3em;\n  }\n}\n\n.who-we-are-container > img {\n  width: auto;\n  max-width: 100%;\n  height: 100%;\n  border-radius: 39% 61% 71% 29% / 41% 45% 55% 59% ;\n}\n\n@media screen and (min-width: 768px) {\n  .who-we-are-container > img {\n    max-width: 50%;\n  }\n}\n\n.who-we-are-paragraphs-container {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  align-items: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
